import { render, staticRenderFns } from "./ViewComfy.vue?vue&type=template&id=6a921125"
import script from "./ViewComfy.vue?vue&type=script&lang=js"
export * from "./ViewComfy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports